import RestService from '@/modules/backend/RestService';
import { MarkAsReadRequestInterface } from '@/modules/backend';
import { FetchEventResult } from '@/modules/backend/Events/FetchEventResult';
import { FetchEventData } from '@/modules/backend/Events/FetchEventData';
import { plainToClass } from 'class-transformer';
import { Event } from '@/modules/backend/Entities/Event';

export default class Events {
  private readonly rest: RestService;

  public constructor(rest: RestService) {
    this.rest = rest;
  }

  public async fetch(payload: FetchEventData): Promise<FetchEventResult> {
    try {
      const result = await this.rest.get('/api/v1/events', {
        params: {
          companyIds: payload.companyIds?.join(','),
          providerIds: payload.providerIds?.join(','),
          limit: payload.limit,
          offset: payload.offset
        }
      });
      return {
        ...result,
        events: plainToClass(Event, result.events),
      };
    } catch {
      return {
        total: 0,
        offset: 0,
        limit: 0,
        events: []
      };
    }
  }

  public async MarkAsRead(payload: MarkAsReadRequestInterface): Promise<boolean> {
    return await this.rest.patch(`/api/v1/event/${payload.Id}`);
  }
}
